/* One selection state feeds totals and the single cart request. */
if (!customElements.get('yk-reference')) customElements.define('yk-reference', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.data = JSON.parse(this.querySelector('[data-product]').textContent);
    this.variant = this.data.variants.find(v => v.id === this.data.current);
    this.selection = {cover:null, carry:null};
    this.count = this.querySelector('[data-count]');
    this.buy = this.querySelector('[data-buy]');
    this.form = this.querySelector('[data-purchase]');
    this.error = this.querySelector('[data-error]');
    this.dialog = this.querySelector('dialog');
    this.preview = this.querySelector('[data-cover-preview] img');
    this.originalImage = this.preview?.src;
    this.money = amount => new Intl.NumberFormat('de-AT', {style:'currency',currency:this.dataset.currency}).format(amount/100);
    this.addEventListener('change', e => {
      if (e.target.matches('[data-carry]')) this.selection.carry = this.read(e.target);
      if (e.target.matches('[data-variant]')) {
        this.selectVariant(this.data.variants.find(v => String(v.id) === e.target.value));
      }
      this.querySelector('[data-success]').hidden = true;
      this.render();
    });
    this.count.addEventListener('input', () => this.render());
    this.addEventListener('click', e => {
      const button = e.target.closest('button'); if (!button) return;
      if (button.dataset.quantity) {this.count.value = Math.max(1,Math.min(99,(Number(this.count.value)||1)+Number(button.dataset.quantity)));this.render();}
      if (button.hasAttribute('data-open')) {
        this.dialog.querySelectorAll('input').forEach(input => input.checked = input.value === (this.selection.cover?.id || ''));
        this.dialog.showModal();
      }
      if (button.matches('.drawer-close')) this.dialog.close();
      if (button.hasAttribute('data-apply')) {this.selection.cover = this.read(this.dialog.querySelector('input:checked'));this.render();this.dialog.close();}
      if (button.hasAttribute('data-remove')) {this.selection.cover=null;this.render();this.querySelector('[data-open]').focus();}
      if (button.dataset.photo) {
        if (this.dataset.accessory) {
          const path = new URL(button.dataset.photo, location.href).pathname;
          let matches = this.data.variants.filter(v => v.featured_image && new URL(v.featured_image.src, location.href).pathname === path);
          // Existing cover files label both views with the exact design name.
          // Only an unambiguous complete label matches; overview images do not.
          if (!matches.length && this.dataset.coverGallery) {
            const label = decodeURIComponent(path.split('/').pop()).replace(/\.[^.]+$/, '').replace(/_[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i, '').replace(/[\s_-]/g, '').toLowerCase();
            matches = this.data.variants.filter(v => v.title.replace(/[\s_-]/g, '').toLowerCase() === label);
          }
          if (matches.length === 1) {this.selectVariant(matches[0]);this.querySelector('[data-success]').hidden=true;this.render();}
        }
        const image=this.querySelector('.main-image');image.removeAttribute('srcset');image.src=button.dataset.photo;image.alt=button.dataset.alt;this.querySelectorAll('[data-photo]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      }
    });
    this.form.addEventListener('submit', e => {e.preventDefault();this.addToCart();});
    this.render();
  }
  selectVariant(variant) {
    if (!variant) return;
    this.variant = variant;
    const select = this.querySelector('[data-variant]');
    if (select) select.value = String(variant.id);
    const backup = this.querySelector('[data-backup]');
    if (backup && !variant.available) backup.checked = false;
    const url = new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
  }
  read(input) {return input?.value ? {id:input.value,title:input.dataset.title,price:Number(input.dataset.price),image:input.dataset.image} : null;}
  setup() {
    const count=Number(this.count.value), extras=Object.values(this.selection).filter(Boolean);
    if(this.querySelector('[data-backup]')?.checked && this.variant.available) extras.push({id:String(this.variant.id),title:'Backup: '+this.data.title,price:this.variant.price});
    return {count,extras,valid:Number.isInteger(count)&&count>=1&&count<=99,total:count*this.variant.price+extras.reduce((sum,item)=>sum+item.price,0)};
  }
  render() {
    const s=this.setup(),v=this.variant;
    if(this.dataset.accessory && this.imageVariant!==v.id){
      this.imageVariant=v.id;
      const image=this.querySelector('.main-image'),src=v.featured_image?.src;
      if(image&&src){image.removeAttribute('srcset');image.src=src;image.alt=this.data.title+' – '+v.title;this.querySelectorAll('[data-photo]').forEach(b=>b.setAttribute('aria-pressed',String(new URL(b.dataset.photo,location.href).pathname===new URL(src,location.href).pathname)));}
      const detail=this.querySelector('[data-detail-variant]');if(detail)detail.textContent=v.title;
    }
    this.buy.disabled=this.busy||!s.valid||!v.available;
    this.buy.textContent=this.busy?'Wird hinzugefügt …':v.available?'In den Warenkorb':'Nicht verfügbar';
    this.form.setAttribute('aria-busy',String(!!this.busy));
    this.count.setAttribute('aria-invalid',String(!s.valid));
    if(!s.valid){this.error.hidden=false;this.error.textContent=this.dataset.quantityError||'Bitte wähle 1 bis 99 YubiKeys.';}else if(!this.requestError){this.error.hidden=true;}
    this.querySelector('[data-total]').textContent=s.valid?this.money(s.total):'–';
    this.querySelector('[data-price]').textContent=this.money(v.price);
    const compare=this.querySelector('[data-compare]');compare.hidden=!(v.compare_at_price>v.price);compare.textContent=this.money(v.compare_at_price||0);
    this.querySelectorAll('[data-stock] [data-variant-id]').forEach(item => item.hidden = item.dataset.variantId !== String(v.id));
    this.querySelector('[name=id]').value=v.id;
    for(const [field,value] of [['sku',v.sku],['mpn',v.barcode]]){this.querySelector('[data-'+field+']').textContent=value||'';this.querySelector('[data-'+field+'-row]').hidden=!value;const detail=this.querySelector('[data-detail-'+field+']');if(detail)detail.textContent=value||'–';}
    const backup=this.querySelector('[data-backup]');if(backup){backup.disabled=!v.available||this.busy;this.querySelector('[data-backup-price]').textContent=this.money(v.price);}
    const summary=this.querySelector('[data-summary]');summary.replaceChildren();
    if(!s.extras.length)summary.textContent='Ohne zusätzliche Extras';
    for(const item of s.extras){const line=document.createElement('span');line.textContent='1 × '+item.title+' · '+this.money(item.price);summary.append(line);}
    this.querySelector('[data-bottom-summary]').textContent=s.extras.length?s.extras.map(x=>x.title).join(' · ')+' — '+this.money(s.total):'Ohne zusätzliche Extras';
    if(this.preview){const item=this.selection.cover;this.preview.removeAttribute('srcset');this.preview.src=item?.image||this.originalImage;this.preview.alt=item?.title||'Cover-Auswahl';this.querySelector('[data-cover-summary]').textContent=item?item.title+' · '+this.money(item.price):'';this.querySelector('[data-open]').textContent=item?'Cover ändern':'Cover auswählen';this.querySelector('[data-remove]').hidden=!item;}
    this.querySelector('[data-quantity="-1"]').disabled=s.count<=1||this.busy;
    this.querySelector('[data-quantity="1"]').disabled=s.count>=99||this.busy;
  }
  async addToCart() {
    const s=this.setup();if(this.busy||!s.valid||!this.variant.available)return;
    const quantities=new Map([[String(this.variant.id),s.count]]);
    s.extras.forEach(item=>quantities.set(item.id,(quantities.get(item.id)||0)+1));
    const items=[...quantities].map(([id,quantity])=>({id:Number(id),quantity}));
    this.busy=true;this.requestError=false;this.querySelector('[data-success]').hidden=true;this.render();
    try {
      const sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
      const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections,sections_url:location.pathname})});
      const result=await response.json();
      if(!response.ok)throw new Error(typeof result.description==='string'?result.description:'Die Auswahl konnte nicht hinzugefügt werden. Bitte prüfe den Warenkorb und versuche es erneut.');
      this.querySelector('[data-success]').hidden=false;
      const cartResponse=await fetch(this.dataset.cartUrl+'.js');
      if(!cartResponse.ok) { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})); return; }
      const cart=await cartResponse.json();cart.sections=result.sections;
      document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart}}));
      this.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:result.items,cart}}));
    } catch(error) {
      this.requestError=true;this.error.hidden=false;this.error.textContent=error.message==='Failed to fetch'?'Verbindung unterbrochen. Bitte prüfe zuerst deinen Warenkorb, bevor du erneut hinzufügst.':error.message;
    } finally {this.busy=false;this.render();}
  }
});
